import {
  LOGGED_IN,
  SAVE_SESSION_EXPIRED_ACTION,
  SET_INFORMATION_SNACKBAR_STATE,
  SET_INFORMATION_SNACKBAR_TEXT,
  SET_DOMAIN_NAME, SET_ACCESS_TOKEN, CONFIG_FETCH_SUCCESS, CONFIG_FETCH_FAILED, SET_LANGUAGE_LIST, ADD_LANGUAGE,
  REMOVE_GROUP_STORAGE
} from './store/mutation-types'

import {
  GET_DROPDOWN_VALUES,
  REFRESH_LOGIN,
  FETCH_USER_ANNOUNCEMENTS,
  APPLY_SESSION_EXPIRED_ACTIONS,
  GET_CONFIG_DETAILS, GET_LANGUAGE_DETAILS, GET_LANGUAGE_DETAILS_PER_LOCALE, GET_CURRENT_ACCESSIBILITY_FLAG
} from './store/action-types'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import Vuetify from 'vuetify'
import vuexI18n from 'vuex-i18n'
import server from './store/server'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faMinusCircle, faPlusCircle, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {informationTexts} from './store/modules/information'
import {messageBus} from './MessageBus'
import VCalendar from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'
import qs from 'qs'
import VueScrollActive from 'vue-scrollactive'
import {LocalizationUtils} from './utils/localization-utils'
import('mdi/css/materialdesignicons.min.css')
import('./main.css')

Vue.use(VueScrollActive)

Vue.use(vuexI18n.plugin, store)
library.add(faMinusCircle, faPlusCircle, faUser)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VCalendar, {
  componentPrefix: 'v',
  firstDayOfWeek: 1, // Sunday is the default
  navVisibility: 'focus',
  titlePosition: 'center',
  titleTransition: 'slide-h', // Horizontal slide
  weeksTransition: 'slide-h',
  dateFormatter: d => d.toLocaleDateString(),
  dateParser: s => new Date(Date.parse(s)),
  datePickerInputClass: '',
  datePickerInputStyle: null,
  datePickerInputPlaceholder: '',
  datePickerSelectColor: '#66B3CC',
  datePickerDragColor: '#9FCFDF', // Only used for drag mode
  datePickerShowCaps: false, // Only used for drag mode
  datePickerShowPopover: true,
  popoverExpanded: false,
  popoverDirection: 'bottom',
  popoverAlign: 'left',
  popoverVisibility: 'hover',
  popoverContentOffset: '10px',
  maxSwipeTime: 300, // ms
  minHorizontalSwipeDistance: 60, // px
  maxVerticalSwipeDistance: 80, // px
  maxTapTolerance: 0, // ms
  maxTapDuration: 200, // ms
  highlight: {
    animated: true,
    height: '1.8rem',
    borderWidth: '0',
    borderStyle: 'solid',
    borderRadius: '290486px',
    opacity: 1
  },
  highlightCaps: {
    animated: true,
    height: '1.9rem',
    borderWidth: '0',
    borderStyle: 'solid',
    borderRadius: '290486px',
    opacity: 1
  },
  dot: {
    diameter: '5px',
    backgroundColor: '#66b3cc',
    borderWidth: '0',
    borderStyle: 'solid',
    borderRadius: '50%',
    opacity: 1
  },
  bar: {
    height: '3px',
    backgroundColor: '#66b3cc',
    borderWidth: '0',
    borderStyle: 'solid',
    opacity: 1
  },
  themeStyles: {
    wrapper: {backgroundColor: '#fafafa', border: '1px solid #dadada'},
    verticalDivider: {borderLeft: '1px solid #dadada'},
    header: {backgroundColor: '#ffffff'},
    dayCellNotInMonth: {opacity: 0.4},
    dayPopoverContent: {
      color: '#333333',
      fontSize: '.8rem',
      whiteSpace: 'nowrap'
    }
  },
  locale: vuexI18n.store.state.locale
})

// Setup default axios responses to error codes
axios.interceptors.response.use(
  (res) => {
    store.dispatch(REFRESH_LOGIN, res)
    return res
  },
  (error) => {
    console.error('Request rejected due to:' + error)
    if (
      // ERR_CONNECTION_REFUSED
      (error.status === undefined && JSON.stringify(error.request) === '{}' && !error.response) ||
      // 500 (Internal Server Error)
      (error.response.status === 500 && error.response.data.exception.includes('DataAccessResourceFailureException')) ||
      // 503 (Service Unavailable)
      (error.response.status === 503)) {
      if (error.response.status !== 406) {
        router.push('/error')
      } else {
      }
    }

    // If we have SAML authentication we need to refresh the page on any 302s
    // returned from the server. unfortunately 302s present as undefined error codes
    /* if ((error.status === undefined || error.status === 406) && store.state.config.useSAML) {
      console.log('Reloading page' + error.status)
      window.location.reload()
    } */
    if ((error.response.status === 401 || error.response.status === 406) && router.currentRoute.name === 'LoginSSO') {
      router.push('/login')
    }
    if (error.response.status === 401 && store.state.config.useSAML) {
      router.push('/unauthorised')
    }
    if ((error.response.status === 401 || error.response.status === 406) && store.state.profile.loggedIn) {
      if (store.state.config.useSAML || store.state.config.useSSO) {
        window.stop()
        server.removeAuthOnPage()
        window.location.replace(store.state.config.authUrlLogOut)
      } else if (error.config.actionData) {
        store.commit(SAVE_SESSION_EXPIRED_ACTION, error.config.actionData)
      }
      return Promise.reject(error)
    }

    // if 500 causes 'Access-Control-Allow-Origin'
    if (error.response === undefined) {
      messageBus.serverError(error)
      return Promise.reject(error)
    } else if (error.response.status === 403) {
      store.commit(SET_INFORMATION_SNACKBAR_TEXT, informationTexts.FORBIDDEN_RESOURCE)
      store.commit(SET_INFORMATION_SNACKBAR_STATE, true)
      router.push('/dashboard')
    } else if ((error.response.status === 500) || (error.response.status === 400)) {
      if (error.response.data.errorType.startsWith('VALIDATION_EXEMPTION')) {
        // Do nothing
      } else {
        messageBus.serverError(error)
      }
      return Promise.reject(error)
    } else {
      // console.log('500 errors error response reject error')
      return Promise.reject(error)
    }
  })

Vue.config.productionTip = false

let authKey = server.getAuthOnPage()
if (authKey) {
  store.commit(LOGGED_IN, authKey)
}

let fetchDomainNamesAndConfig = (store) => {
  // console.info('Fetching domain names and config...')
  let baseUrl = window.location.protocol + '//' + window.location.hostname
  let port = window.location.port || (window.location.protocol === 'https' ? '443' : '80')
  // let port = 8080
  store.commit(SET_DOMAIN_NAME, {baseUrl: baseUrl, port: port})

  const data = qs.stringify({
    grant_type: 'password',
    username: 'frontend-user',
    password: 'pass'
  })
  let url = `${baseUrl}/stream-auth/oauth/token`
  // let url = `${baseUrl}:${port}/stream-auth/oauth/token`
  axios({
    headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
    method: 'post',
    url: url,
    auth: {
      username: 'frontend-user',
      password: 'secret'
    },
    data
  }).then((res) => {
    store.commit(SET_ACCESS_TOKEN, res.data.access_token)
    let tok = res.data.access_token
    axios({
      url: `${baseUrl}/core/config/all`,
      // url: `${baseUrl}:${port}/core/config/all`,
      method: 'get',
      headers: {
        'Authorization': tok
      },
      actionData: {action: GET_CONFIG_DETAILS}
    }).then((res) => {
      store.commit(CONFIG_FETCH_SUCCESS, res.data)
      Vue.use(Vuetify, {theme: res.data.theme})
      if (res.data.pageTitle !== undefined && res.data.pageTitle !== '') {
        document.title = res.data.pageTitle
      }
      axios({
        url: `${baseUrl}/core/translation/language`,
        // url: `${baseUrl}:${port}/core/translation/language`,
        method: 'get',
        headers: {
          'Authorization': tok
        },
        actionData: {action: GET_LANGUAGE_DETAILS}
      }).then(async(res) => {
        store.commit(SET_LANGUAGE_LIST, res.data)
        let languagesList = res.data
        const utils = new LocalizationUtils()
        Vue.i18n.set(utils.getPreferredLanguage(languagesList))
        for (let language of languagesList) {
          store.commit(ADD_LANGUAGE, language)
          axios({
            url: `${baseUrl}/core/translation/language/${language.name}`,
            // url: `${baseUrl}:${port}/core/translation/language/${language.name}`,
            method: 'get',
            headers: {
              'Authorization': tok
            },
            actionData: {action: GET_LANGUAGE_DETAILS_PER_LOCALE}
          })
            .then((res) => {
              Vue.i18n.add(language.name, res.data)
            })
            .catch((err) => {
              console.error(`Errored while trying to fetch language specific for locale from core: ` + err)
            })
        }
        Vue.i18n.fallback(utils.getFallbackLanguage(languagesList))

        let path = window.location.pathname

        // Only load if logged in

        if (store.state.config.useSAML) {
          try {
            // let uri = `${baseUrl}:${port}/core/samllogin`
            let uri = `${baseUrl}/core/samllogin`
            let response = await axios.post(uri, {})
            if (response.headers.authorization) {
              store.commit(LOGGED_IN, response.headers.authorization)
              server.setAuthOnPage(response.headers.authorization)
              store.dispatch(APPLY_SESSION_EXPIRED_ACTIONS)
              // store.dispatch(GET_TUTOR_BOOLEAN)
              // store.dispatch(GET_CHART_LIMIT_BOOLEAN)
              store.dispatch(GET_DROPDOWN_VALUES)
              store.dispatch(FETCH_USER_ANNOUNCEMENTS)
              // store.dispatch(GET_ENGAGEMENT_LAST_SUCCESSFUL)
              store.commit(REMOVE_GROUP_STORAGE, {})
              if (store.getters.IS_STUDENT) {
                store.dispatch(GET_CURRENT_ACCESSIBILITY_FLAG)
              }
              router.push(path)
            }
          } catch (err) {
            console.error('Error in login useSAML, login failed due to: ' + err)
            router.push('/unauthorised')
          }
        } else {
          if (store.state.profile.loginToken) {
            store.dispatch(GET_DROPDOWN_VALUES)
            store.dispatch(FETCH_USER_ANNOUNCEMENTS)
            // store.dispatch(GET_ENGAGEMENT_LAST_SUCCESSFUL)
            if (store.getters.IS_STUDENT) {
              store.dispatch(GET_CURRENT_ACCESSIBILITY_FLAG)
            }
          }
        }
        /* eslint-disable no-new */
        new Vue({
          el: '#app',
          store,
          router,
          render: h => h(App)
        })
      })
        .catch((err) => {
          console.error(`Errored while trying to fetch language from core: ` + err)
        })
    })
      .catch((err) => {
        console.error(`Errored while trying to fetch config from core: ` + err)
        store.commit(CONFIG_FETCH_FAILED, err)
      })
  })
    .catch((err) => {
      console.log(`Errored while trying to fetch access token: ` + err)
    })
}

fetchDomainNamesAndConfig(store)



// WEBPACK FOOTER //
// ./src/main.js